<template>
  <v-card class="elevation-9">
    <v-toolbar color="default" v-show="titulo" primary-title class="title font-weight-bold elevation-0">
        {{titulo}}
        </v-toolbar>
    <v-card-text class="text-sm-left mx-2">
     
      <v-subheader v-show="subheader">{{subheader}}</v-subheader>
      <v-layout v-for="(item,index) in requisitos" :key="index" row wrap class="px-2">
        <v-flex v-if="item.icon" lg1 md1 sm1 xs1>
          <v-avatar icon :size="35">
            <v-icon small  :class="[item.iconClass]">{{ item.icon }}</v-icon>
          </v-avatar>
        </v-flex>
        <v-flex lg11 md11 sm11 xs11 class="px-3">
          <div class="font-weight-medium">{{item.title}}</div>
          <p v-if="item.subtitle!=null" class="caption grey--text  text--darken-1" v-html="item.subtitle"></p>
          <v-btn
            v-if="item.archivo!=null"
            color="primary"
            small
            @click="descargarArchivo(item.archivo,item.nombreArchivo)"
          >
            <v-icon class="pr-2">cloud_download</v-icon>Descargar
          </v-btn>
          <v-btn v-if="item.ejemplo!=null" color="gray" small>
            <v-icon>remove_red_eye</v-icon>Ejemplo de Llenado
          </v-btn>
        </v-flex>
        <!-- <v-divider :inset="true"></v-divider> -->
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["titulo", "requisitos", "subheader", "archivo", "ejemplo"],
  methods: {
    descargarArchivo(file,nombre) {
      const link = document.createElement("a");
          link.href = file;
          link.setAttribute("download",nombre);
          document.body.appendChild(link);
          link.click();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Registro/Requisito.vue